import Header from './components/Header'

const App = () => {
  return (
    <div className='container'>
        <Header></Header>
    </div>
  )
}
export default App;